

// Only archive CMM reports in production
export function shouldArchiveCmmReports() {
    return import.meta.env.APP_ENV === 'production';
}
